import React, { useEffect, useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from './Footer';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

const FAQ = () => {
  const [faqData, setFaqData] = useState([]);
  const [faqImage, setFaqImage] = useState('');
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    axios
      .get('https://api.techsterker.com/api/faq')
      .then((res) => {
        const data = res.data.data[0];
        setFaqImage(data.image || '');
        setFaqData(data.faq || []);
      })
      .catch((err) => console.error('FAQ API Error:', err));
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Header />

      <Container
        className="py-5 mt-5"
        style={{ maxWidth: '1140px', fontFamily: 'Roboto, sans-serif' }}
      >
        {/* FAQ Title */}
        <Row className="text-center mb-5">
          <Col>
            <h2 className="fw-bold text-dark mb-1 fs-3 fs-md-2 fs-lg-1">
              Frequently Asked{' '}
              <span style={{ color: '#a51d34' }}>Questions</span>
            </h2>
          </Col>
        </Row>

        {/* FAQ Image Section */}
        {faqImage && (
          <Row className="justify-content-center mb-5">
            <Col xs={12} md={8} lg={6}>
              <Image
                src={faqImage}
                alt="FAQ Banner"
                fluid
                rounded
                className="border border-light"
              />
            </Col>
          </Row>
        )}

        {/* FAQ List */}
        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <div className="accordion">
              {faqData.map((faq, index) => (
                <div
                  key={faq._id}
                  className="border-bottom border-light pb-3 mb-3"
                >
                  <div
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => toggleFAQ(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <h3 className="fw-bold text-dark mb-0 fs-6 fs-sm-5 fs-md-4">
                      {String(index + 1).padStart(2, '0')}. {faq.question}
                    </h3>
                    <span className="textcolor ms-3">
                      {openIndex === index ? <FaMinus /> : <FaPlus />}
                    </span>
                  </div>
                  {openIndex === index && (
                    <p className="mt-3 text-muted fs-6 fs-sm-6 fs-md-5">
                      {faq.answer}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default FAQ;
